import React, { useState } from "react";
import {
  Typography,
  Container,
  Box,
  InputLabel,
  Button,
  Grid,
  TextField,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import { registerSIM } from "./api/machineApi";
import { useHistory } from "react-router-dom";

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          fontWeight: "bold",
          marginBottom: "4px",
          display: "block",
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          fontSize: "0.75rem",
          padding: "4px 8px",
        },
      },
    },
  },
});

const StyledFormBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#ffffff",
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}));

const RequiredStar = styled("span")(({ theme }) => ({
  color: theme.palette.error.main,
}));

const RegisterSIM = () => {
  const [formData, setFormData] = useState({
    simNumber: "",
    imsiNumber: "",
    mobileNumber: "",
    userName: "",
    designation: "",
    billPlan: "",
    billType: "",
  });

  const history = useHistory();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const result = await registerSIM(formData);
      console.log("SIM Registered:", result);
      alert("SIM registered successfully!");
      history.push("/machine-overview");
    } catch (error) {
      console.error("Error:", error);
      alert(error.message || "Failed to register SIM");
    }
  };

  const handleCancel = () => {
    console.log("Registration cancelled");
    setFormData({
      simNumber: "",
      imsiNumber: "",
      mobileNumber: "",
      userName: "",
      designation: "",
      billPlan: "",
      billType: "",
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md">
        <Box mt={3} mb={2}>
          <Typography variant="h5" component="h1" gutterBottom>
            Register SIM
          </Typography>
          <StyledFormBox>
            <Grid container spacing={1}>
              {[
                { label: "SIM Number", name: "simNumber" },
                { label: "IMSI Number", name: "imsiNumber" },
                { label: "Mobile Number", name: "mobileNumber" },
                { label: "User Name", name: "userName" },
                { label: "Designation", name: "designation" },
              ].map(({ label, name }) => (
                <Grid item xs={12} sm={6} key={name}>
                  <InputLabel htmlFor={name}>
                    {label} <RequiredStar>*</RequiredStar>
                  </InputLabel>
                  <TextField
                    id={name}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    fullWidth
                    required
                  />
                </Grid>
              ))}
              {[
                {
                  label: "Bill Plan",
                  name: "billPlan",
                  options: [
                    "Prepaid Unlimited",
                    "Postpaid Limited",
                    "Enterprise",
                  ],
                },
                {
                  label: "Bill Type",
                  name: "billType",
                  options: ["Corporate", "Personal"],
                },
              ].map(({ label, name, options }) => (
                <Grid item xs={12} sm={6} key={name}>
                  <InputLabel htmlFor={name}>
                    {label} <RequiredStar>*</RequiredStar>
                  </InputLabel>
                  <FormControl fullWidth required>
                    <Select
                      id={name}
                      name={name}
                      value={formData[name]}
                      onChange={handleChange}
                    >
                      <MenuItem value="">
                        <em>Select</em>
                      </MenuItem>
                      {options.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ))}
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5 }}>
              <Button onClick={handleCancel}>Cancel</Button>
              <StyledButton
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                type="submit"
              >
                Register
              </StyledButton>
            </Box>
          </StyledFormBox>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default RegisterSIM;
